import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRotate360Right: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="rotate-360-right"><path d="M10.25 13.25L13.25 16.25L10.25 19.25" stroke="currentColor" strokeWidth="1.5"/><path d="M17.125 15.5476C20.1887 14.6399 22.25 12.9432 22.25 11C22.25 8.10051 17.6609 5.75 12 5.75C6.33908 5.75 1.75 8.10051 1.75 11C1.75 13.8995 6.33908 16.25 12 16.25H13" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconRotate360Right;
